import { render } from "./GameEditData.vue?vue&type=template&id=4f830d2e"
import script from "./GameEditData.vue?vue&type=script&lang=js"
export * from "./GameEditData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__